<template>
  <div class="table-section">
    <div class="operation">
      <div class="operation-left" v-html="$t('warehousingAudit.totalCount', [currentCount])"></div>
      <div class="operation-right">
        <div class="search">
          <el-input clearable size="small"
            :placeholder="corpusActive === 'memory' ? $t('warehousingAudit.pleasebankeMemoryName') : $t('warehousingAudit.pleasebankeTermName')"
            v-model="filter.name" @clear="handleChangeSearch" @keyup.enter.native="handleChangeSearch">
          </el-input>
          <el-button class="search-btn" icon="el-icon-search" size="small" type="primary" @click="handleChangeSearch">
          </el-button>
        </div>
        <el-popover :title="$t('projectV2.filter')" trigger="click" popper-class="popover-warehousAudit"
          placement="bottom">
          <el-button class="filter" size="small" slot="reference">
            <i></i>
            {{ $t('projectV2.filter') }}
          </el-button>
          <ul>
            <li>
              <span class="popover-label">{{ $t('newProjectV2.langPair') }}</span>
              <el-select size="small" v-model="filter.langDesc" clearable :placeholder="$t('newProjectV2.langPairTip')">
                <el-option v-for="(item, index) in langOptions" :key="index"
                  :label="$i18n.locale === 'zh' ? item.langDesc.replace('>', ' — ') : $langCase[item.sourceLang] + ' — ' + $langCase[item.targetLang]"
                  :value="item.langDesc"></el-option>
              </el-select>
            </li>
            <li>
              <span class="popover-label">{{ $t('newProjectV2.domain') }}</span>
              <el-select size="small" v-model="filter.domainCode" clearable :placeholder="$t('newProjectV2.domainTip')">
                <el-option v-for="(item, index) in domainOptions" :key="index"
                  :label="$i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode]"
                  :value="item.domainCode">
                </el-option>
              </el-select>
            </li>
            <li class="btn">
              <el-button @click="handleChangeFilter(0)">{{ $t('projectV2.clear') }}</el-button>
              <el-button type="primary" @click="handleChangeFilter(1)">{{ $t('projectV2.search') }}
              </el-button>
            </li>
          </ul>
        </el-popover>
      </div>
    </div>
    <el-table ref="warehousingTable" :data="tableData" cell-class-name="cellClassName" v-loading="tableLoading"
      header-cell-class-name="headerCellClassName" height="calc(100% - 111px)" border style="width: 100%"
      @sort-change="changeSort">
      <el-table-column type="index" :index="indexMethod" :label="$t('termBankV2.number')" width="60" align="center" />
      <el-table-column prop="name"
        :label="corpusActive === 'memory' ? $t('newProjectV2.memoryBankName') : $t('newProjectV2.termBankName')"
        show-overflow-tooltip align="center" min-width="180">
        <template slot-scope="{row}">
          <p class="slot-text bank-name" @click="handlerDetail(row)">{{ row.name }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="langDesc" :label="$t('newProjectV2.langPair')" show-overflow-tooltip align="center">
        <template slot-scope="{row}">
          <p class="slot-text">
            {{ $i18n.locale === 'zh' ? row.langDesc && row.langDesc.replace('>', ' - ') :
              getEnlang(row.sourceLang, row.targetLang) }}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="domainName" :label="$t('newProjectV2.domain')" show-overflow-tooltip align="center">
        <template slot-scope="{row}">
          <p class="slot-text">
            {{ $i18n.locale === 'zh' ? row.domainName : getEnDomain(row.domainCode) }}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="sentCount" :label="$t('newProjectV2.sentNum')" show-overflow-tooltip align="center" />
      <el-table-column prop="createTime" :label="$t('warehousingAudit.submissionTime')" show-overflow-tooltip
        align="center" sortable="custom" min-width="100" />

      <el-table-column prop="reviewTime" :label="$t('warehousingAudit.reviewTime')" show-overflow-tooltip align="center"
        sortable="custom" min-width="100">
        <template slot-scope="{row}">
          <span>{{ row.reviewTime ? row.reviewTime : '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reviewerName" :label="$t('warehousingAudit.auditor')" show-overflow-tooltip align="center">
        <template slot-scope="{row}">
          <span>{{ row.reviewerName ? row.reviewerName : '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('projectV2.state')" show-overflow-tooltip align="center" width="100">
        <template slot-scope="{row}">
          <span :class="`status-${row.status}`">{{ statusObj[row.status] }}</span>
        </template>
      </el-table-column>
      <!-- 
        已入库：查看
        审核中：查看、取消
        已退回：查看、编辑、重新入库、删除
        已取消：查看、编辑、入库、删除
       -->
      <el-table-column :label="$t('projectV2.operation')" align="center" width="160">
        <template slot-scope="{row}">
          <div class="iconList">
            <!-- 查看 -->
            <el-tooltip effect="dark" :content="$t('common.view')" placement="top">
              <i class="iconList-item icon-view" @click="handlerDetail(row)" />
            </el-tooltip>
            <!-- <el-tooltip v-if="activeName==='first'" effect="dark"
                        :content="$t('memoryBankV2.downLoad')" placement="top">
              <i class="iconList-item icon-download" @click="handleDownload(row)" />
            </el-tooltip> -->
            <!-- 取消 -->
            <el-tooltip v-if="activeName === 'second'" effect="dark" :content="$t('warehousingAudit.cancelBanke')"
              placement="top">
              <i class="iconList-item icon-cancel" @click="handleCancelBank(row)" />
            </el-tooltip>
            <!-- 编辑 -->
            <el-tooltip v-if="activeName === 'third' || activeName === 'fourth'" effect="dark"
              :content="$t('warehousingAudit.editor')" placement="top">
              <i class="iconList-item icon-editor" @click="handleEditorBank(row)" />
            </el-tooltip>
            <!-- 重新入库 -->
            <el-tooltip v-if="activeName === 'third' || activeName === 'fourth'" effect="dark"
              :content="$t('warehousingAudit.restorage')" placement="top">
              <i class="iconList-item icon-restorage" @click="handleWarehouseBank(row)" />
            </el-tooltip>
            <!-- 删除 -->
            <el-tooltip v-if="activeName === 'third' || activeName === 'fourth'" effect="dark"
              :content="$t('warehousingAudit.delete')" placement="top">
              <i class="iconList-item icon-delete" @click="handleDeleteBank(row)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="paginationInfo.total" :page.sync="paginationInfo.page" :limit.sync="paginationInfo.rows"
      :pagerCount="paginationInfo.pagerCount" :layout="paginationInfo.layout" @pagination="handlePagination">
    </pagination>
    <!-- 取消入库 --> <!--入库 -->
    <warehousing-dialog :corpusDetailInfo="corpusDetailInfo" :bankType="corpusActive" :isWarehousing="isWarehousing"
      :dialogVisible="warehousingVisible" @handleClose="handleWarehousingClose" @handleConfirm="handleWarehousingConfirm">
    </warehousing-dialog>

    <!-- 下载库 -->
    <download-corpus-dialog :bankType="corpusActive" :corpusDetailInfo="corpusDetailInfo"
      :dialogVisible="downloadBankVisible" @handleClose="downloadBankVisible = false">
    </download-corpus-dialog>

    <!-- 编辑 -->
    <editCorpus :dialogVisible="editorBankVisible" :bankType="corpusActive" :corpusDetailInfo="corpusDetailInfo"
      @handleClose="editorBankVisible = false" @handleConfirm="handleEditorBankConfirm">
    </editCorpus>
    <!-- 删除库弹窗 -->
    <DeleteDialog :dialogVisible="deleteBankVisible" @handleClose="deleteBankVisible = false"
      @handleConfirm="handleDeleteBankConfirm">
    </DeleteDialog>
  </div>
</template>

<script>
import { removeProperty } from '@/utils';
import { queryRecordPage, cancel, deleteRecord,reWarehousing } from '../../../services/warehousingAudit';
import WarehousingDialog from './warehousingDialog.vue';
import { delTerm, termQuerySentCount, termPutInStorage } from '@/services/term';
import { memoryPutInStorage } from '@/services/memoryBank';
import DownloadCorpusDialog from './downloadCorpusDialog.vue';
import EditCorpus from './editCorpus.vue';
import DeleteDialog from './deleteDialog.vue';
export default {
  name: 'WarehousAuditTabTable',
  components: {
    WarehousingDialog,
    DownloadCorpusDialog,
    EditCorpus,
    DeleteDialog
  },
  props: {
    // 翻译记忆库|术语库 tab选中
    corpusActive: {
      type: String,
      default: 'memory'
    },
    // 翻译记忆库1|术语库2 
    corpusType: {
      type: Number,
      default: 1
    },
    // 已入库|审核中|已退回 tab选中
    activeName: {
      type: String,
      default: 'first'
    },
    // 统计数量
    countRecordsInfo: {
      type: Object,
      default: () => { }
    },
    // 下拉选择列表 
    selectOptions: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      tableLoading: true,
      tableData: [],
      // 分页器参数
      paginationInfo: {
        total: 0,
        page: 1,
        rows: 10,
        pagerCount: 5,
        layout: 'prev, pager, next, sizes',
      },
      filter: {
        name: '',
        langDesc: '',
        domainCode: '',
      },
      sort: {},
      // 控制入库弹窗
      warehousingVisible: false,
      // 控制下载弹窗
      downloadBankVisible: false,
      corpusDetailInfo: {},
      statusObj: {
        1: this.$t('warehousingAudit.toBeReviewed'),
        2: this.$t('memory.Stockin'),
        3: this.$t('managementV2.returned'),
        4: this.$t('managementV2.canceled')
      },
      corpusDetailObj: {
        memory: 'wareMemoryDetail',
        term: 'wareTermbankDetail'
      },
      editorBankVisible: false, //编辑弹窗
      isWarehousing: false,// true取消入库 false入库
      deleteBankVisible: false, //删除弹窗
    }
  },
  watch: {
    corpusActive: {
      handler(newVal) {
        // console.log(newVal, this.activeName, '---');
        this.getQueryPage()
      },
      immediate: true
    },
    'paginationInfo.page': {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.warehousingTable.bodyWrapper.scrollTop = 0
          })
        }
      }
    }
  },
  computed: {
    /**
     * @desc 状态类型转化 string(this.activeName)=>number(1|2|3)
     * @return {Number} 返回 (1|2|3)
     */
    statusType() {
      const obj = {
        first: 2,   // 已入库
        second: 1,  // 审核中
        third: 3,   // 已退回
        fourth: 4,  // 已取消
      }
      return obj[this.activeName]
    },

    /**
     * @desc 显示当前tab总条数
     * @return {Number}
     */
    currentCount() {
      const obj = {
        first: 'receivedCount',
        second: 'underReviewCount',
        third: 'failPassCount'
      }
      return this.countRecordsInfo[obj[this.activeName]]
    },

    langOptions() {
      return this.selectOptions.langDescList || []
    },
    domainOptions() {
      return this.selectOptions.domainList || []
    },
    ajaxObj() {
      // 记忆库接口方法
      const memoryAjaxObj = {
        corpusPutInStorage: memoryPutInStorage
      }
      // 术语库接口方法
      const termAjaxObj = {
        deleteCorpusBank: delTerm,
        getSentCount: termQuerySentCount,
        corpusPutInStorage: termPutInStorage
      }
      const routeTypeObj = {
        memory: memoryAjaxObj,
        term: termAjaxObj
      }
      return routeTypeObj[this.corpusActive]
    }
  },

  methods: {
    // 排序
    changeSort({ prop, order }) {
      this.sort = {}
      this.sort[prop] = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : null
      this.sort = removeProperty(this.sort)
      this.getQueryPage()
    },
    // 获取列表数据
    async getQueryPage() {
      const params = {
        filter: removeProperty({ ...this.filter }),
        page: this.paginationInfo.page,
        rows: this.paginationInfo.rows,
        sort: this.sort,
      }
      params.filter.corpusType = this.corpusType
      params.filter.status = this.statusType
      this.tableLoading = true
      const { success, list, totalRows } = await queryRecordPage(params)
      this.tableLoading = false
      if (!success) {
        this.tableData = []
        this.paginationInfo.total = 0
      } else {
        this.tableData = [...list]
        this.paginationInfo.total = totalRows
      }
    },

    // 表格序号
    indexMethod(index) {
      let i = index + 1
      return i < 10 ? `0${i}` : i;
    },

    handlePagination({ page, limit }) {
      this.getQueryPage()
    },

    handleChangeSearch() {
      this.paginationInfo.page = 1
      this.getQueryPage()
    },

    // 筛选
    handleChangeFilter(type) {
      if (!type) {
        for (const key in this.filter) {
          if (key !== 'name') {
            this.filter[key] = ''
          }
        }
        this.paginationInfo.page = 1
        this.getQueryPage()
      } else {
        this.paginationInfo.page = 1
        this.getQueryPage()
      }
    },

    handlerDetail(row) {
      this.$router.push({
        name: this.corpusDetailObj[this.corpusActive],
        query: {
          key: this.$Base64.encode(JSON.stringify({
            row,
            type: 'warehousing',
            corpusType: this.corpusType
          }))
        }
      });
    },

    handleDownload(row) {
      this.corpusDetailInfo = {
        id: row.targetLibId
      }
      this.downloadBankVisible = true
    },
    //取消
    handleCancelBank(row) {
      this.corpusDetailInfo = { ...row, notStockCount: row.sentCount }
      this.isWarehousing = true
      this.warehousingVisible = true
    },
    //编辑
    handleEditorBank(row) {
      this.corpusDetailInfo = { ...row }
      this.corpusDetailInfo.id = row.targetLibId
      this.editorBankVisible = true
      console.log(row, '@@##44', this.corpusActive);
    },
    handleEditorBankConfirm(data) {
      this.editorBankVisible = false
      data && this.getQueryPage()
    },
    //入库
    handleWarehouseBank(row) {
      this.corpusDetailInfo = { ...row, notStockCount: row.sentCount }
      this.isWarehousing = false
      this.warehousingVisible = true
    },
    //删除
    handleDeleteBank(row) {
      this.corpusDetailInfo = row
      this.deleteBankVisible = true
    },
    async handleDeleteBankConfirm() {
      const params = {
        id: this.corpusDetailInfo.id,
        corpusType: this.corpusType,
      }
      const { success } = await deleteRecord(params)
      if (!success) return
      this.$message.closeAll();
      this.$message.success(this.$t('termBankV2.deleteSuccess'))
      this.deleteBankVisible = false
      this.getQueryPage()
      this.$emit('updateCurrentCount')
    },
    handleWarehousingClose() {
      this.warehousingVisible = false
    },
    // 确定取消入库或入库
    async handleWarehousingConfirm(data) {
      if (this.isWarehousing) { //取消入库
        const params = {
          corpusType: this.corpusType,
          id: data.id
        }
        const { success } = await cancel(params)
        if (!success) return
        this.$message.closeAll()
        this.$message.success(this.$t('homeworkManage.cancelSuccessful'))

      } else { //重新入库
        const params = {
            id: data.id,
            corpusType: this.corpusType,
            name: data.name,
            remark: data.remark
          }
          const { success , result } = await reWarehousing(params)
          if (!success) return
          this.$message.closeAll()
          this.$message.success(this.$t('memory.Warehousingsucceeded'))
      }
      this.warehousingVisible = false
      this.getQueryPage()
      this.$emit('updateCurrentCount')
    },

  }
}
</script>

<style lang="less" scoped>
.table-section {
  height: 100%;
}

.operation {
  margin-bottom: 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-right {
    display: flex;
    align-items: center;

    .search {
      display: flex;
      align-items: center;
      margin-right: 15px;

      /deep/.el-input__inner {
        height: 32px;
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .search-btn {
        border: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;

        /deep/.el-icon-search::before {
          color: #fff;
          font-size: 14px;
        }
      }
    }

    .filter {
      padding: 8px 13px;
      border-color: 1px solid #e5e7eb;
      color: #5c6a86;

      i {
        width: 14px;
        height: 14px;
        display: inline-block;
        vertical-align: -2px;
        background: url("~@/assets/imgs/common/icon-filter.png");
        margin-right: 5px;
      }
    }
  }
}

/deep/.el-table {
  .headerCellClassName {
    padding: 5px 0;
    font-weight: bold;
    color: #566087;
    background: #e4edfc;
  }

  .cellClassName {
    padding: 10px 0;
  }

  .slot-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .bank-name {
    color: #0078fc;
    text-decoration: underline;
    cursor: pointer;
  }

  // #0078FC 审核中|#00CC91 已入库|#9CA9BD 已退回
  .status-1 {
    color: #0078fc;
  }

  .status-2 {
    color: #00cc91;
  }

  .status-3 {
    color: #9ca9bd;
  }

  .iconList {
    display: flex;
    align-items: center;
    justify-content: center;

    &-item {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .iconList-item+.iconList-item {
      margin-left: 15px;
    }

    .icon-view {
      background: url("../images/view.png") no-repeat center;

      &:hover {
        background: url("../images/view_pre.png") no-repeat center;
      }
    }

    .icon-download {
      background: url("~@/assets/imgs/homework/icon-download.png") no-repeat center;

      &:hover {
        background: url("~@/assets/imgs/homework/icon-download-pre.png") no-repeat center;
      }
    }

    .icon-cancel {
      // background: url("../images/icon-cancel.png") no-repeat center;
      background: url("~@/assets/imgs/memory/icon_no_nor.png") no-repeat center;

      &:hover {
        background: url("~@/assets/imgs/memory/icon_no_pre.png") no-repeat center;
      }
    }

    .icon-editor {
      background: url("../images/editor.png") no-repeat center;

      &:hover {
        background: url("../images/editor_pre.png") no-repeat center;
      }
    }

    .icon-restorage {
      background: url("../images/operation_icon_export_pre.png") no-repeat center;
      background-size: contain;

      &:hover {
        background: url("../images/operation_icon_export_pre-1.png") no-repeat center;
      }
    }

    .icon-delete {
      background: url("../images/deleter.png") no-repeat center;

      &:hover {
        background: url("../images/deleter_pre.png") no-repeat center;
      }
    }
  }
}

/deep/.el-pagination {
  margin-top: 30px;
}
</style>
<style lang="less">
.popover-warehousAudit {
  .el-popover__title {
    font-weight: bold;
  }

  ul {
    width: 200px;

    li+li {
      color: #454545;
      text-align: left;
      margin-top: 12px;
    }

    li {
      .popover-label {
        display: flex;
      }

      .el-select {
        width: 100%;

        .el-input {
          width: 100%;
        }
      }

      .el-button+.el-button {
        margin-left: 20px;
      }

      .el-button {
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
      }

      .el-button--default {
        color: #0078fc;
        border: 1px solid #0078fc;
      }
    }

    .btn {
      text-align: center;
    }
  }
}
</style>

